<app-main-navigation></app-main-navigation>
<div class="app-container navbar-margin">
    <img src="assets/images/features.png" alt="">
</div>